module.exports = __webpack_public_path__ + "static/media/work.3dda4d2e.svg";